module.exports = __webpack_public_path__ + "img/guide-code.824f2621.png";